import {Component, OnChanges, OnInit} from '@angular/core';
import {BaseComponent} from '../../core/base.component';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {AccountService} from '../account.service';
import {AuthService} from '../../core/security/auth.service';
import {UntypedFormBuilder} from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import 'moment-timezone';
import {AccountStorageModel} from '../../api/models/account-storage-model';
import {RecordingsPlanModel} from '../../api/models/recordings-plan-model';
import {MatDialog} from '@angular/material/dialog';
import {StorageRetentionDialogComponent} from './storage-retention-dialog.component';
import {RolesEnum} from '../../core/security/roles.enum';
import { FlexModule } from '@angular/flex-layout';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatFormFieldFix } from '../../editors/mat-form-field/mat-form-field-fix';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { NgFor, NgIf, DecimalPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

@Component({
    selector: 'app-storage-retention',
    templateUrl: './storage.component.html',
    styleUrls: ['./storage.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatCard,
        MatCardTitle,
        MatCardContent,
        MatFormFieldFix,
        MatFormField,
        MatLabel,
        MatSelect,
        NgFor,
        MatOption,
        NgIf,
        MatButton,
        Angular2PromiseButtonModule,
        DecimalPipe,
    ],
})
export class StorageComponent extends BaseComponent implements OnInit, OnChanges {

  public payPlanSubmitPromise: Promise<void>;

  public companyPlansModel: AccountStorageModel = {};
  public currentRecordingsPlan: RecordingsPlanModel = {};

  public maxDaysList: any[] = [
    {value: -1, text: 'Unlimited Days'},
    {value: 30, text: '30 Days'},
    {value: 60, text: '60 Days'},
    {value: 90, text: '90 Days'},
    {value: 120, text: '120 Days'},
    {value: 190, text: '6 Months'},
    {value: 365, text: '1 Year'},
    {value: 730, text: '2 Years'},
    {value: 1095, text: '3 Years'},
    {value: 1460, text: '4 Years'},
    {value: 1825, text: '5 Years'},
    {value: 2190, text: '6 Years'},
    {value: 2555, text: '7 Years'},
  ];
  public advancedOptions = false;

  daysLimit = -1;
  planLimitsChanged = false;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public dialog: MatDialog,
              private accountService: AccountService,
              private fb: UntypedFormBuilder,
              private notificationService: NotificationService) {
    super(route, headerService, titleService, authService);

    this.headerService.showBackButton(true);
    this.onChangePlanConfirm = this.onChangePlanConfirm.bind(this);
  }

  async ngOnInit() {
    super.ngOnInit();

    this.companyPlansModel = await this.accountService.getCompanyStorage();
    this.currentRecordingsPlan = this.companyPlansModel.currentRecordingsPlan;
    this.ngOnChanges();
  }

  onPlanLimitsChange(item: any) {
    this.planLimitsChanged = true;
  }

  async onChangePlanConfirm(): Promise<void> {
    this.payPlanSubmitPromise = this.processSubmit(this.currentRecordingsPlan);
  }

  async processSubmit(plan: RecordingsPlanModel): Promise<void> {

    try {
      console.log(plan);
      this.companyPlansModel = await this.accountService.saveRecordingsRetentionPlan(plan);
      this.planLimitsChanged = false;
      if (this.authService.hasAccess([RolesEnum.Support])) {
        this.notificationService.notifySuccess('Settings updated successfully');
        this.companyPlansModel = await this.accountService.getCompanyStorage();
      } else {
        this.notificationService.notifySuccess('Your request to change your retention limit has been submitted. A member of our team will contact you shortly. ');
      }

      this.ngOnChanges();
    } catch (e) {
      console.error(e);
    }
  }

  ngOnChanges() {
    const storageModel = this.companyPlansModel;
    const currentPlan = storageModel.currentRecordingsPlan;

    this.daysLimit = currentPlan.daysLimit || -1;
    this.advancedOptions = !!currentPlan.hoursLimit;
  }

  onRecordingsPlanChanged(currentRecordingsPlan: RecordingsPlanModel) {
    this.currentRecordingsPlan.daysLimit = this.daysLimit === -1 ? null : this.daysLimit;

    const dialogRef = this.dialog.open(StorageRetentionDialogComponent, {
      width: '500px',
      data: {
        recordingsPlan: this.currentRecordingsPlan,
      }
    });

    dialogRef.afterClosed().subscribe(async (results) => {
      if (results) {
        await this.onChangePlanConfirm();
      }
    });
  }
}
